import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LoginAlert from "../LoginAlert/LoginAlert";
import NewFilter from "../FilterOrders/NewFilter";
import { useOrders } from "../../pages/DefaultPage/connect/Orders";
import SearchInput from "../SearchInput/SearchInput";

function DesktopHeader() {
  const [isShowLogoutModal, setIsShowLogOutModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const {
    getExchange,
    getMasterOrders,
    getAdsPicMasterByMasterPriorityId,
    getAdsMasterSearch,
    getDetailMasterByQueryByAllStrings,
  } = useOrders((state) => state.actions);
  const allMasterOrders = useOrders((state) => state.allMasterOrders);

  const location = useLocation();
  const [activeMenuItem, setActiveMenuItem] = useState(3);
  const [showLoginAlert, setShowLoginAlert] = useState(false);
  const navigate = useNavigate();
  const desMenuItems = [
    { id: 5, title: "خانه", src: "/desktop/icons/home.svg", link: "/AllADS" },
    {
      id: 1,
      title: "دسته بندی ها",
      src: "/desktop/icons/category.svg",
      link: "/CategoryView",
    },
    {
      id: 2,
      title: "ثبت آگهی",
      src: "/desktop/icons/add.svg",
      link: "/RegisterAD",
    },
    { id: 3, title: "همه آگهی ها", src: "/desktop/icons/all.svg", link: "/" },
    {
      id: 4,
      title: "پروفایل",
      src: "/desktop/icons/profile.svg",
      link: "/Profile",
    },
  ];
  const checkAuthForAddOrder = (id) => {
    setActiveMenuItem(id);
    console.log(id);
    // setActiveMenuItem(id)
    if (localStorage.getItem("veeuAuthData")) {
      if (id == 4) {
        navigate("/Profile");
      } else if (id == 2) {
        navigate("/RegisterAD");
      }
    } else {
      setShowLoginAlert(true);
    }
  };
  const [isSearch, setIsSearch] = useState(false);

  const searchHandler = () => {
    setIsSearch(true);
    if (searchValue.length > 2) {
      getAdsMasterSearch(searchValue, 0);
    }
    if (searchValue == "") {
      // getMastersHandler();used to cause error on search
      setIsSearch(false);
    }
  };
  console.log("ljkljkl-------111", setIsSearch);
  const getMastersHandler = async () => {
    if (allMasterOrders && allMasterOrders.length == 0) {
      await getMasterOrders();
    }
    // allMasterOrders.map(item => {
    //     console.log("jknmkj");
    //     getAdsPicMasterByMasterPriorityId(item.id , 1)
    // })
  };
  const closeModalsWithClickOnDocument = (e) => {
    if (e.target.className.includes("style-for-close-on-outside")) {
      document.removeEventListener("click", setIsShowLogOutModal(false));
    }
  };
  const [openSuccess, setOpenSuccess] = useState(false);
  const handleYes = () => {
    localStorage.clear();
    setIsShowLogOutModal(false);
    setOpenSuccess(true);
    setTimeout(() => {
      navigate("/");
    }, 2000);
  };




  const [suggestions, setSuggestions] = useState([]);
  const [history, setHistory] = useState([]);
  const [pinned, setPinned] = useState([]);

  // const { getAdsMasterSearch } = useOrders((state) => state.actions);
  const dropDownRef = useRef(null)
  const allSuggestions = [
    "فروش مسکونی",
    "فروش آپارتمان اداری",
    "فروش خانه و ویلا",
    "فروش زمین",
    "فروش دفتر کار",
    "فروش تجاری",
  ];

  useEffect(() => {
    // Load the last search value from localStorage on component mount
    if (isSearch) {
      const savedSearchValue = localStorage.getItem('searchValue');
      if (savedSearchValue) {
        setSearchValue(savedSearchValue);
      }
    } else {
      setSearchValue("");
    }

    // Load search history from localStorage on component mount
    const savedHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
    setHistory(savedHistory);

    // Load pinned suggestions from localStorage on component mount
    const savedPinned = JSON.parse(localStorage.getItem('pinnedSuggestions')) || [];
    setPinned(savedPinned);

    document.addEventListener('click', handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('click', handleClickOutside);
    }
  }, []);
  // console.log("ljkljkl" , searchValue);
  console.log("ljkljkl-------", setIsSearch);
  // console.log("ljkljkl5555" , localStorage.getItem("searchValue"));



  const handleClickOutside = (event) => {
    if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
      setSuggestions([]);
      // console.log("outside");

    }
  };
  // const handleInputChange = (e) => {
  //     const value = e.target.value;
  //     setSearchValue(value);

  //     // Save current input value to localStorage
  //     localStorage.setItem('searchValue', value);

  //     // Show suggestions if "فروش" is in the input value
  //     if (value.includes("فروش")) {
  //         setSuggestions(allSuggestions.filter(suggestion => suggestion.includes(value)));
  //     } else {
  //         setSuggestions([]);
  //     }

  //     if (value.trim() == "") {
  //         //TODO  
  //     }
  // };

  const handleFocus = () => {
    // Show search history when input is focused, with pinned items at the top
    if (history.length > 0 || pinned.length > 0) {
      const combinedSuggestions = [...pinned, ...history.filter(item => !pinned.includes(item))];
      setSuggestions(combinedSuggestions);
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    // setIsSearch(true)
    if (searchValue.length > 2) {
      setIsSearch(true)

      // onSearch(searchValue);
      // searchHandler()
      // getAdsMasterSearch(searchValue, 0);
      setSuggestions([]); // Clear suggestions after searching

      // Save search to history
      const updatedHistory = [searchValue, ...history.filter(item => item !== searchValue)].slice(0, 8); // Max 8 items
      setHistory(updatedHistory);
      localStorage.setItem('searchHistory', JSON.stringify(updatedHistory));
    }
  };
  const clickedOnSuggestion = (suggestion) => {
    getAdsMasterSearch(suggestion, 0);
  }
  const clearHistory = () => {
    localStorage.removeItem('searchHistory');
    setHistory([]);
    setSuggestions(pinned); // Keep pinned items visible
  };

  const handlePin = (suggestion) => {
    const updatedPinned = [suggestion, ...pinned.filter(item => item !== suggestion)];
    setPinned(updatedPinned);
    localStorage.setItem('pinnedSuggestions', JSON.stringify(updatedPinned));
  };

  const handleUnpin = (suggestion) => {
    const updatedPinned = pinned.filter(item => item !== suggestion);
    setPinned(updatedPinned);
    localStorage.setItem('pinnedSuggestions', JSON.stringify(updatedPinned));
  };
  const handleInputChange = (event) => {
    setSearchValue(event.target.value);
  };


  return (
    <>
      <div className="sm:hidden md:hidden lg:hidden flex items-center justify-between p-4  border-b fixed  top-0  w-full bg-white z-50 ">
        <div className="flex items-center gap-6 xl:gap-2  xl:w-full lg:gap-1 w-full">
          <Link to={"/"}>
            <img src="/desktop/icons/logoWithFream.svg" alt="veeu" />
          </Link>
          <div className="bg-gray-300 w-[2px] h-[50px] "></div>
          {location.pathname === "/" ||
            location.pathname.slice(0, 18) == "/buildingMaterials" ||
            location.pathname.slice(0, 7) == "/metals" ||
            location.pathname.slice(0, 15) == "/services-labor" ||
            location.pathname.slice(0, 10) == "/equipment" ||
            location.pathname.slice(0, 14) == "/machine-tools" ||
            location.pathname.slice(0, 21) == "/architect-contractor" ||
            location.pathname.slice(0, 20) == "/CommissionCalculate" ||
            location.pathname === "/RegisterAD" ||
            location.pathname === "/CategoryView" ||
            location.pathname === "/AllADS" ||
            location.pathname === "/LoginStepOne" ||
            location.pathname === "/LoginLocation" ||
            location.pathname === "/LoginSecondStep" ||
            location.pathname === "/LoginThirdStep" ||
            location.pathname === "/property" ||
            location.pathname.slice(0, 16) === "/AdvertiseDetail" ||
            location.pathname.slice(0, 9) === "/ChatPage" ||
            location.pathname.slice(0, 11) === "/User" ||
            location.pathname === "/Messages" ||
            location.pathname === "/AdsOnMap" ||
            location.pathname === "/Blogs" ||
            location.pathname === "/Ads" ||
            location.pathname.includes('Blog') ||
            location.pathname === "/SplashView" ?
            (

              <div className="flex justify-between w-full">
                <div className="flex items-center">
                  <div className="flex items-center ml-2">
                    {localStorage.getItem("veeuToken") ? (
                      <button className="bg-gray-200 rounded-lg hover:text-white shadow-[0px_0px_1px_0px_#00FF3899] group-change-location-icon transition-all flex py-1 gap-1 items-center justify-center px-5 p-2   text-green-800  ">
                        <span>
                          {localStorage.getItem("locationNameVeeu")
                            ? JSON.parse(localStorage.getItem("locationNameVeeu"))
                              .locName
                            : "تهران"}
                        </span>
                        <div className="bg-cover bg-center w-[20px] h-[20px] bg-img-location"></div>
                      </button>
                    ) : (
                      <Link
                        to={"/LoginStepOne"}
                        className="shadow-[0px_0px_1px_0px_#00FF3899] flex py-1 gap-1 items-center justify-center px-5 p-2  text-green-800 rounded rounded-lg"
                      >
                        <p>ورود</p>
                        <img src="icons/login.svg" alt="" />
                      </Link>
                    )}
                  </div>
                  <div className="grid grid-cols-1 gap-2 ">
                    <div className="">
                      <div className="w-full  flex items-center rounded-lg   xl:justify-between">
                        <div className="flex items-center relative xl:w-full">
                          <div ref={dropDownRef} className='w-full relative flex items-center rounded-md border border-1  '>
                            <div className="flex items-center w-full md:relative">
                              {/* <img src="/icons/LogoInSearch.svg" className='pr-1 px-2' alt="icon" /> */}
                              {/* <form onSubmit={handleSubmit}>
                                <div className='flex items-center w-full'>
                                  <input
                                    onChange={handleInputChange}
                                    onFocus={handleFocus}
                                    value={searchValue}
                                    className='w-full texr-sm bg-transparent border-none outline-none transition-all duration-700'
                                    type="text"
                                    placeholder="جست و جو"
                                  />
                                </div>
                                <button className="absolute w-6 h-6 left-2 top-[5px] ">
                                  <svg onClick={handleSubmit} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                                  </svg>
                                </button>
                              </form> */}
                              <SearchInput onSearch={searchHandler}/>
                              {/* Display suggestions and history */}
                              {suggestions.length > 0 && (
                                <ul className="absolute top-full mt-2 left-0 w-full bg-white border border-gray-300 rounded-md shadow-lg">
                                  <p className='text-[#B90023] text-sm m-1 text-end' onClick={() => clearHistory()}>حذف تاریخچه جست و جو </p>
                                  {suggestions.map((suggestion, index) => (
                                    <li key={index} className="px-4 py-2 flex items-center justify-between cursor-pointer hover:bg-gray-100">
                                      <span
                                        onClick={(e) => {
                                          setSearchValue(suggestion);
                                          localStorage.setItem('searchValue', suggestion); // Save selected suggestion to localStorage
                                          setSuggestions([]); // Clear suggestions after selection
                                          clickedOnSuggestion(suggestion)
                                        }}
                                      >
                                        {suggestion}
                                      </span>
                                      {pinned.includes(suggestion) ? (
                                        <img src='/icons/green-pin.svg' alt='Unpin' onClick={() => handleUnpin(suggestion)} />
                                      ) : (
                                        <img src='/icons/gray-unpin.svg' alt='Pin' onClick={() => handlePin(suggestion)} />
                                      )}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex ">
                  {desMenuItems.map((item) =>
                    item.id == 4 || item.id == 2 ? (
                      <div
                        onClick={() => checkAuthForAddOrder(item.id)}
                        key={item.id}
                        className={`${item.id == 2 && "text-[#B90023] font-bold"
                          } hover:bg-[#F3F3F3] hover:rounded-md transition-all cursor-pointer flex items-center gap-1 p-2 transition-all 
                                ${activeMenuItem == item.id
                            ? "border-b border-b border-b-2 border-b-gray-600 font-bold "
                            : "border-none"
                          }`}
                      >
                        <img src={item.src} alt={item.alt} className="" />
                        <h2>{item.title}</h2>
                      </div>
                    ) : (
                      <Link
                        onClick={() => setActiveMenuItem(item.id)}
                        key={item.id}
                        to={item.link}
                        className={`cursor-pointer flex items-center gap-1 p-2 transition-all hover:text-gray-700 hover:bg-[#F3F3F3] hover:rounded-md transition-all
                                ${activeMenuItem == item.id
                            ? "border-b border-b-2 border-b-gray-600 font-bold "
                            : "border-none"
                          }`}
                      >
                        <img src={item.src} alt={item.alt} />
                        <h2>{item.title}</h2>
                      </Link>
                    )
                  )}
                </div>
              </div>

            ) :
            (<div>

              {localStorage.getItem("veeuToken") ? <div
                onClick={() => setIsShowLogOutModal(true)}
                className="cursor-pointer flex items-center rounded-md border border-1 bg-white  px-4 py-1 group gap-1"
              >
                <img src="/desktop/icons/logout.svg" alt="" />
                <p className="group-hover:font-bold transition-all">
                  خروج
                </p>
              </div> : <Link
                to={"/LoginStepOne"}
                className="shadow-[0px_0px_1px_0px_#00FF3899] flex py-1 gap-1 items-center justify-center px-5 p-2  text-green-800 rounded rounded-lg"
              >
                <p>ورود</p>
                <img src="icons/login.svg" alt="" />
              </Link>}

            </div>

            )}

        </div>

      </div>
      <div
        onClick={(e) => closeModalsWithClickOnDocument(e)}
        className={`right-0 sm:hidden md:hidden style-for-close-on-outside ${isShowLogoutModal ? "top-0" : "top-[100000px] "
          } fixed duration-700 w-full h-screen bg-[#8d8d8da1] transition-all flex justify-center items-center z-50`}
      >
        {/* <div className='flex justify-center items-center rounded-lg bg-white w-[50%] flex-col text-center pb-12 pl-4 pr-4 pt-2 shadow-[0px_-1px_10px_1px_#000000] bg-white'> */}
        <div
          className={`z-50 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 border-5 rounded-xl p-4 bg-red-400 text-white flex flex-col items-center justify-center gap-4 w-80 shadow-sm`}
        >
          <p className="text-xl font-bold">آیا از خروج اطمینان دارید؟</p>
          <div className="flex justify-around items-center w-full">
            <button
              onClick={handleYes}
              className="mx-3 w-1/2 text-white-900 px-6 py-2 rounded-xl bg-red-500 z-50"
            >
              بله
            </button>
            <button
              onClick={() => setIsShowLogOutModal(false)}
              className="mx-3 w-1/2 text-red-800 px-6 py-2 rounded-xl bg-orange-500 z-50 "
            >
              خیر
            </button>
          </div>
        </div>
        {/* </div> */}
      </div>
      {/* <div className={`  ${openSuccess ? "top-0" : "top-[100000px] "} z-50 duration-1000  absolute w-full h-screen`}>
                <div className='rounded-xl p-4 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white flex bg-green-700 flex-col items-center justify-center w-[40%] shadow-sm'>
                    <p className='text-xl font-bold'>با موفقیت خارج شدید</p>
                </div>
            </div> */}
      {/* <NewFilter/> */}
      {showLoginAlert ? (
        <LoginAlert
          showLoginAlert={showLoginAlert}
          setShowLoginAlert={setShowLoginAlert}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default DesktopHeader;
